import React from 'react'
import { Navigate } from 'react-router-dom'

import { getTeamsLandingRoute } from '@msteams/components/Navigation/landing'
import type { TeamsScope } from '@msteams/components/Navigation/landing'
import { useGetMyAccount } from '@queries/Account'

/**
 * Element for the routers' index / `/tab` / `/dashboard` entries. AuthLayout
 * blocks render until the account query resolves, so `user` is settled by
 * the time this mounts; `replace` keeps the redirect out of history so the
 * back button does not bounce through it. `scope` names the router, since
 * the channel tab registers far fewer pages than the personal app.
 */
const TeamsLanding: React.FC<{ scope: TeamsScope }> = ({ scope }) => {
  const { data: user } = useGetMyAccount()
  return <Navigate to={getTeamsLandingRoute(user, scope)} replace />
}

export default TeamsLanding
